import { defineMessages } from 'react-intl';

export const upmVersionTranslations = defineMessages({
  upmVersion: {
    id: 'upmVersion.version',
    defaultMessage: 'UPM: {version}',
    description: 'UPM Version text',
  },
});
